import Taichi_01 from 'assets/images/pictures/taichi/taichi_01.jpg';
import Taichi_02 from 'assets/images/pictures/taichi/taichi_02.jpg';
import Taichi_03 from 'assets/images/pictures/taichi/taichi_03.jpg';
import Taichi_04 from 'assets/images/pictures/taichi/taichi_04.jpg';
import Taichi_05 from 'assets/images/pictures/taichi/taichi_05.jpg';
import Taichi_06 from 'assets/images/pictures/taichi/taichi_06.jpg';
import Taichi_07 from 'assets/images/pictures/taichi/taichi_07.jpg';
import Taichi_08 from 'assets/images/pictures/taichi/taichi_08.jpg';

const TaichiSlides = [
  //   {
  //     id: 0,
  //     component: (
  //       <YoutubeEmbed
  //         embedId='JgM_l3yPdK4?si=CqtxlzgdyFdM9EIG'
  //         title='活力秘技'
  //       />
  //     ),
  //   },
  {
    id: 1,
    component: (
      <img
        src={Taichi_01}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Taichi 01'
      />
    ),
  },
  {
    id: 2,
    component: (
      <img
        src={Taichi_02}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Taichi 02'
      />
    ),
  },
  {
    id: 3,
    component: (
      <img
        src={Taichi_03}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Taichi 03'
      />
    ),
  },
  {
    id: 4,
    component: (
      <img
        src={Taichi_04}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Taichi 04'
      />
    ),
  },
  {
    id: 5,
    component: (
      <img
        src={Taichi_05}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Taichi 05'
      />
    ),
  },
  {
    id: 6,
    component: (
      <img
        src={Taichi_06}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Taichi 06'
      />
    ),
  },
  {
    id: 7,
    component: (
      <img
        src={Taichi_07}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Taichi 07'
      />
    ),
  },
  {
    id: 8,
    component: (
      <img
        src={Taichi_08}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Taichi 08'
      />
    ),
  },
];

export default TaichiSlides;
